// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.cdnfonts.com/css/times-new-roman);"]);
// Module
exports.push([module.id, "*[data-v-7401aeef]{font-family:Times New Roman,sans-serif!important}", ""]);
// Exports
module.exports = exports;
